<template>
	<CardSection :title="processTitle" :loading="loading" :expandable="true" :isExpanded="isExpanded">
		<v-container fluid>
			<v-row>
				<LabelData :label="$t('ProcessNumber')" :data="processInfo.processNumber" />
				<LabelData :label="$t('ReferenceNumber')" :data="processInfo.referenceNumber" />
				<LabelData :label="$t('Status')" :data="$t(processInfo.status)" />
				<LabelData :label="$t('CreatedDate')" :data="processInfo.createdDate | formatDateTimeGregorian" />
				<LabelData :label="$t('Stage')" :data="$t(processInfo.stage)" />
				<LabelData :label="$t('ProcessType')" :data="processInfo.processType" />
			</v-row>
		</v-container>
</CardSection>
</template>
<script>
	import TasksService from '@/services/TasksService.js'

	import CardSection from '@/components/controls/CardSection.vue'
	import LabelData from '@/components/controls/LabelData.vue'

	export default {

		components: {
			CardSection,
			LabelData
		},

		props: {
			taskId: {
				type: Number,
				default: null
			}
		},

		data() {
			return {
				loading: false,
				isExpanded: false,
				processInfo: {
					processTitle: null,
					processNumber: null,
					referenceNumber: null,
					status: null,
					createdDate: null,
					stage: null,
					processType: null,
				}
			}
		},

		computed: {
			processTitle() {
				return this.$t('ProcessTitle') + ': ' + this.processInfo.processTitle
			}
		},

		created() {
			this.getProcessInfo()
		},

		methods: {

			getProcessInfo() {

				this.loading = true

				TasksService.getProcessInfo(this.taskId)
					.then(response => {
						this.processInfo = response.data
					})
					.catch(() => {

					}).finally(() => {
						this.loading = false
					})
			}
		}
	}


</script>